import { isHastElement } from "../types.js";
function buildChildAttributes(params) {
  const { node, filterTagName } = params;
  if (!node) return [];
  const children = node?.children || [];
  const attrsOfChildren = children.filter((child) => {
    if (!isHastElement(child)) return false;
    return filterTagName ? child.tagName === filterTagName : true;
  }).map((child) => {
    const props = child.properties || {};
    const { dataAttrs, ...restProps } = props;
    const parsed = typeof dataAttrs === "string" ? safeJSONParse(dataAttrs) : {};
    return { ...restProps, ...parsed };
  }).filter((attr) => attr !== null);
  return attrsOfChildren;
}
function safeJSONParse(value) {
  try {
    return JSON.parse(value || "{}");
  } catch {
    console.error("Failed to parse JSON:", value);
    return {};
  }
}
export {
  buildChildAttributes
};
//# sourceMappingURL=build-child-attributes.js.map
